require('./bootstrap');

window.BpmnModeler = require('camunda-bpmn-js/lib/camunda-platform/Modeler')

$(document).ready(function () {

    $('[data-toggle="tooltip"]').tooltip();

    const sidebarList = document.querySelectorAll('.sidebar-platform .sidebar-list .li-parent');
    const sidebarContent = document.querySelector('.sidebar-platform .sidebar-content');
    if(sidebarList.length){
        sidebarList.forEach((li, index) => {
            const nextLi = li.nextElementSibling;
            li.addEventListener('mouseover', () => {
                sidebarContent.style.overflow = 'visible';
                index === 0 ? li.style.top = '-50px' : li.style.top = `${index * 50}px`;
            });
            li.addEventListener('mouseout', () => {
                sidebarContent.style.overflow = null;
                li.style.top = null;
            })
        });
    }

    $('.tree-toggle').click(function () {
        if($('#app').hasClass('menu-open')){
            $(this).parent().children('ul.tree-content').slideToggle(200);
            $(this).toggleClass('active');
        }
    });

    $('.menu-trigger').click(function () {
        const app = $('#app');
        const nextState = app.hasClass('menu-open') ? 0 : 1;
        const setOpenMenuUrl = window.platformSetOpenMenuUrl || '/set_open_menu';

        axios.get(setOpenMenuUrl, {
            params: {
                state: nextState
            }
        }).then(resp => {
            console.log(resp.data);
        });

        if (nextState) {
            app.addClass('menu-open');
        } else {
            app.removeClass('menu-open');
        }
    })

    $(".filter-trigger").on("click", function (event) {
        event.stopPropagation();
        $("#filter_block").slideToggle(200);
        $(this).toggleClass('active')
    });
});
